import { AppConfig } from '@core/domain/AppConfig.ts';
import type { LocalSqliteRuntime } from '@src/modules/shared/local-sqlite/domain/LocalSqliteRuntime.ts';
import { readBrowserStorageEstimate } from '@src/modules/shared/local-sqlite/domain/browserStorageEstimate.ts';
import { RedencionBonoApplicationService } from '../../application/RedencionBonoApplicationService.ts';
import { SqlJsRedencionBonoRepository } from '../driven/SqlJsRedencionBonoRepository.ts';

/** Creates the application service instance for redemptions. */
export function createRedencionBonoApplicationService(
  runtime: LocalSqliteRuntime,
): RedencionBonoApplicationService {
  const db = runtime.getDb();
  if (!db) {
    throw new Error('Local SQLite is required for RedencionBonoApplicationService');
  }
  return new RedencionBonoApplicationService(
    new SqlJsRedencionBonoRepository(db, () => runtime.notifyPersist(), AppConfig.getFilesPublicPrefix()),
    {
      flushAfterMutation: () => runtime.flushPersist(),
      readStorageEstimate: readBrowserStorageEstimate,
    },
  );
}
